import './css/CheckInDetail.css'

import { Fragment, useEffect, useState } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { Button, Space, Row } from 'antd'
import { baseAxiosComplete, baseAxiosNoInfo } from '../../tool/axios'

import AddPaymentMoney from './components/AddPaymentMoney'
import AddLeftMoney from './components/AddLeftMoney'
import AddOtherMoeny from './components/AddOtherMoeny'
import AddRefundMoney from './components/AddRefundMoney'
import AddServicePerson from './components/AddServicePerson'
import AddStoreAcross from './components/AddStoreAcross'
import AddMinionFollow from './components/AddMinionFollow'
import AddCustomerComplaint from './components/AddCustomerComplaint'
import AddBabyService from './components/AddBabyService'
import AddCheckInInterview from './components/AddCheckInInterview'
import AddCheckOutFollow from './components/AddCheckOutFollow'
import OperateChargeBack from './components/OperateChargeBack'
import OperateNotifyCheckIn from './components/OperateNotifyCheckIn'
import OperateCheckIn from './components/OperateCheckIn'
import OperateCheckAheadOut from './components/OperateCheckAheadOut'
import OperateCheckOut from './components/OperateCheckOut'
import OperateChangeRoom from './components/OperateChangeRoom'
import OperateCheckContinue from './components/OperateCheckContinue'

import CustomerInfo from './components/CustomerInfo'
import CustomerCheckInInfo from './components/CustomerCheckInInfo'
import CustomerBabyInfo from './components/CustomerBabyInfo'
import CustomerServiceInfo from './components/CustomerServiceInfo'

import RecordSalesFollow from './components/RecordSalesFollow'
import RecordVisitStore from './components/RecordVisitStore'
import RecordPay from './components/RecordPay'
import RecordRefund from './components/RecordRefund'
import RecordMinionFollow from './components/RecordMinionFollow'
import RecordCheckInDetail from './components/RecordCheckInDetail'
import RecordCheckInInterview from './components/RecordCheckInInterview'
import RecordOtherIncome from './components/RecordOtherIncome'

interface Client {
    check_in_pay_desc: string, // 入住付款状态描述
    check_in_id: string // 入住id
    check_in_user_name: string // 客人姓名
    check_in_phone: string // 手机号码
    preg_status_desc: string // 怀孕时期
    expect_born_day: string // 预产期（预计入住时间）
    actually_born_day: string // 分娩日
    check_in_time: string // 实际入住时间
    check_out_time_init: string // 预计出所时间
    check_out_time_finally: string // 实际出所时间
    emergency_man_name: string // 紧急联系人
    emergency_phone: string // 紧急联系人手机号
    accompany_man_name: string // 陪护人
    accompany_phone: string // 陪护人手机号
    check_in_total_days: number // 入住总天数，整数类型
    check_in_already_days: number // 已入住天数，整数类型
    check_in_left_days: number // 剩余天数，整数类型
    deal_item_name: string // 签单套餐名称
    item_days: number // 套餐入住天数，整数类型
    gift_days: number // 赠送天数，整数类型
    deal_records_remark: string // 签单备注
    store_id: string // 签单门店id
    deal_prov_pic_list: string // 合同凭证图片
    already_notify: number // 是否通知入住，0未通知 1已通知，整数类型，当为1时候前端点击“通知入住”需要调用“入住客户管理-已预订-查询通知信息”接口填充各个字段且禁用各个字段
    check_in_status: number  // 入住状态，0待分配 1已预订 2已入住 3已出所
    current_room_number: string // 当前入住房号，可能为空
}

interface checkInRecordData {
    room_number: string,
    check_in_day_range: string,
    room_type_name: string
}

interface person {
    check_in_id: string
    belong_minion_id: string // 责任管家id
    belong_minion_name: string, // 责任管家名称
    belong_cleaner_id: string, // 生活助理（保洁）id
    belong_cleaner_name: string, // 生活助理（保洁）名称
    belong_nurse_id: string, // 责任护士id
    belong_nurse_name: string, // 责任护士名称，冗余字段
    belong_dietician_id: string, // 营养师id
    belong_dietician_name: string, // 营养师名称
    belong_recover_id: string, // 产康师id
    belong_recover_name: string, // 产康师名称
    belong_look_after_id: string, // 护理师id
    belong_look_after_name: string, // 护理师名称
}

export default function () {

    const [tabCurrent, setTabCurrent] = useState<number>(0)
    const [clientData, setClientData] = useState<Client>()
    const [checkInRecordData, setCheckInRecordData] = useState<checkInRecordData[]>([])
    const [servicedata, setServiceData] = useState<person>()

    const param: { id: string } = useParams()
    const [statusStr, setStatusStr] = useState<string>('')

    const history = useHistory()

    useEffect(() => {
        getClientInfo()
        getCheckInRecord()
        getServiceInfo()
    }, [])

    // 查询客户信息
    const getClientInfo = () => {
        baseAxiosNoInfo('/keeper/check_in/detail/base_info', {
            params: {
                check_in_id: param.id
            }
        }).then((res: any) => {
            if (res) {
                switch (res.check_in_status) {
                    case 0:
                        setStatusStr('待分配')
                        break
                    case 1:
                        setStatusStr('已预订')
                        break
                    case 2:
                        setStatusStr('已入住')
                        break
                    case 3:
                        setStatusStr('已出所')
                        break
                    case 4:
                        setStatusStr('跨店转入待分配')
                        break
                    case 5:
                        setStatusStr('跨店转出')
                        break
                    case 6:
                        setStatusStr('客户退单')
                        break
                }

                setClientData(res)
            }
        })
    }

    // 查询入住信息
    const getCheckInRecord = () => {
        baseAxiosNoInfo('/keeper/check_in/detail/room_info', {
            params: {
                check_in_id: param.id
            }
        }).then((res: any) => {
            if (res) {
                setCheckInRecordData(res)
            }
        })
    }

    // 查询服务人员信息
    const getServiceInfo = () => {
        baseAxiosNoInfo('/keeper/check_in/detail/service_employee_info', {
            params: {
                check_in_id: param.id
            }
        }).then((res: any) => {
            res && setServiceData(res)
        })
    }

    return <div className="common-level2-edit h-detail">
        {/* 管家中心 -> 入住管理 -> 客户详情 */}
        <p className="modules-h2">客户详情</p>

        <div className="clear" style={{ paddingLeft: 16, marginBottom: 16 }} >
            <Button size="small" onClick={() => {
                // window.history.go(-1)
                history.replace({
                    pathname: '/check_in_manage',
                    state: history.location.state
                })
            }} >返回</Button>
        </div>

        {/* 待分配 || 跨店转入待分配 */}
        {(clientData?.check_in_status == 0 || clientData?.check_in_status === 4) && <Space direction="horizontal" wrap>
            <Row gutter={20} style={{ marginLeft: 12, marginBottom: 12 }}>
                {/* 录入尾款 */}
                {/* <AddLeftMoney storeID={clientData?.store_id} /> */}

                {/* 录入收款 */}
                <AddPaymentMoney storeID={clientData?.store_id} />
                <AddOtherMoeny storeID={clientData?.store_id} />
                {/* 服务人员并排房 */}
                <AddServicePerson storeID={clientData?.store_id} onFinish={() => {
                    getClientInfo()
                    getCheckInRecord()
                    getServiceInfo()
                }} />
                {/* 跨店转房 */}
                <AddStoreAcross onChange={() => { }} />
                {/* 客户退单 */}
                {/* <OperateChargeBack onChange={() => {
                getClientInfo()
                getCheckInRecord()
                getServiceInfo()
            }} /> */}
            </Row>
        </Space>}

        {/* 已预定 */}
        {clientData?.check_in_status === 1 && <Space direction="horizontal" wrap>
            <Row gutter={20} style={{ marginLeft: 12, marginBottom: 12 }}>
                {/* 录入尾款 */}
                {/* <AddLeftMoney storeID={clientData?.store_id} /> */}

                {/* 录入收款 */}
                <AddPaymentMoney storeID={clientData?.store_id} />
                <AddOtherMoeny storeID={clientData?.store_id} />
                <AddMinionFollow />
                <OperateNotifyCheckIn onChange={getClientInfo} clientData={clientData} checkInRecordData={checkInRecordData} />
                <OperateCheckIn serviceData={servicedata} checkInRecordData={checkInRecordData} onChange={() => {
                    getClientInfo()
                    getCheckInRecord()
                    getServiceInfo()
                }} storeID={clientData?.store_id} />
                <OperateChangeRoom onChange={() => {
                    getClientInfo()
                    getCheckInRecord()
                    getServiceInfo()
                }} clientData={clientData} checkInRecordData={checkInRecordData} />
                {/* 跨店转房 */}
                <AddStoreAcross onChange={() => { }} />
            </Row>
        </Space>}

        {/* 已入住 */}
        {clientData?.check_in_status === 2 && <Space direction="horizontal" wrap>
            <Row gutter={20} style={{ marginLeft: 12, marginBottom: 12 }}>
                {/* 录入尾款 */}
                {/* <AddLeftMoney storeID={clientData?.store_id} /> */}

                {/* 录入收款 */}
                <AddPaymentMoney storeID={clientData?.store_id} />
                {/* 录入退款 */}
                <AddRefundMoney storeID={clientData?.store_id} />
                <AddCustomerComplaint />
                <AddBabyService onFinish={() => {
                    getClientInfo()
                    getCheckInRecord()
                    getServiceInfo()
                }} />
                <AddCheckInInterview />
                <OperateChangeRoom onChange={() => {
                    getClientInfo()
                    getCheckInRecord()
                    getServiceInfo()
                }} clientData={clientData} checkInRecordData={checkInRecordData} />
                <OperateCheckAheadOut storeID={clientData?.store_id} onChange={() => {
                    getClientInfo()
                    getCheckInRecord()
                    getServiceInfo()
                }} />
                <OperateCheckOut clientData={clientData} onChange={() => {
                    getClientInfo()
                    getCheckInRecord()
                    getServiceInfo()
                }} />
                <OperateCheckContinue clientData={clientData} onChange={() => {
                    getClientInfo()
                    getCheckInRecord()
                    getServiceInfo()
                }} />
                <AddOtherMoeny storeID={clientData?.store_id} />
                {/* 跨店转房 */}
                <AddStoreAcross onChange={() => { }} />
            </Row>
        </Space>}

        {/* 已出所 */}
        {clientData?.check_in_status === 3 && <Space direction="horizontal" wrap>
            <Row gutter={20} style={{ marginLeft: 12, marginBottom: 12 }}>
                {/* 录入尾款 */}
                {/* <AddLeftMoney storeID={clientData?.store_id} /> */}
                {/* 录入收款 */}
                {/* <AddPaymentMoney storeID={clientData?.store_id} /> */}

                <AddCheckInInterview />
                <AddCustomerComplaint />
                <AddOtherMoeny storeID={clientData?.store_id} />
                <AddCheckOutFollow />

                <Button type="primary" style={{ marginLeft: 16, marginBottom: 16 }} size="small" onClick={() => {
                    baseAxiosComplete('/keeper/check_in/detail/download_check_out_statements', {
                        params: {
                            check_in_id: param.id
                        }

                    }).then(res => {
                        if (res.status == 0) {
                            window.open(res.data)
                        }
                    })
                }}>下载离所结算单</Button>
            </Row>
        </Space>}

        {/* 客户信息 */}
        <CustomerInfo status={statusStr} data={clientData} onChange={() => {
            getClientInfo()
            getCheckInRecord()
            getServiceInfo()
        }} />

        {/* 入住信息 */}
        {clientData?.check_in_status !== 0 && <CustomerCheckInInfo status={statusStr} data={checkInRecordData} onFetched={() => {
            getClientInfo()
            getCheckInRecord()
        }} />}

        {/* 宝宝信息 */}
        <CustomerBabyInfo status={statusStr} />

        {/* 服务人员信息 */}
        <CustomerServiceInfo status={statusStr} serviceData={servicedata} storeID={clientData?.store_id} onChange={() => {
            getClientInfo()
            getCheckInRecord()
            getServiceInfo()
        }} />

        <Space direction="horizontal" wrap className="tab clear" style={{ width: '95%' }}>
            <div className={tabCurrent === 0 ? 'tab-btn fl current' : 'tab-btn fl'} onClick={() => { setTabCurrent(0) }}>销售跟进记录</div>
            <div className={tabCurrent === 1 ? 'tab-btn fl current' : 'tab-btn fl'} onClick={() => { setTabCurrent(1) }}>销售进店记录</div>
            <div className={tabCurrent === 2 ? 'tab-btn fl current' : 'tab-btn fl'} onClick={() => { setTabCurrent(2) }}>收款记录</div>
            <div className={tabCurrent === 8 ? 'tab-btn fl current' : 'tab-btn fl'} onClick={() => { setTabCurrent(8) }}>退款记录</div>

            {clientData?.check_in_status === 1 && <Fragment>
                <div className={tabCurrent === 3 ? 'tab-btn fl current' : 'tab-btn fl'} onClick={() => { setTabCurrent(3) }}>管家跟进记录</div>
                <div className={tabCurrent === 4 ? 'tab-btn fl current' : 'tab-btn fl'} onClick={() => { setTabCurrent(4) }}>入住记录</div>
            </Fragment>}

            {(clientData?.check_in_status === 2 || clientData?.check_in_status === 4) && <Fragment>
                <div className={tabCurrent === 3 ? 'tab-btn fl current' : 'tab-btn fl'} onClick={() => { setTabCurrent(3) }}>管家跟进记录</div>
                <div className={tabCurrent === 4 ? 'tab-btn fl current' : 'tab-btn fl'} onClick={() => { setTabCurrent(4) }}>入住记录</div>
                <div className={tabCurrent === 5 ? 'tab-btn fl current' : 'tab-btn fl'} onClick={() => { setTabCurrent(5) }}>入住回访记录</div>
                <div className={tabCurrent === 7 ? 'tab-btn fl current' : 'tab-btn fl'} onClick={() => { setTabCurrent(7) }}>其他收入</div>
            </Fragment>}

            {clientData?.check_in_status === 3 && <Fragment>
                <div className={tabCurrent === 3 ? 'tab-btn fl current' : 'tab-btn fl'} onClick={() => { setTabCurrent(3) }}>管家跟进记录</div>
                <div className={tabCurrent === 4 ? 'tab-btn fl current' : 'tab-btn fl'} onClick={() => { setTabCurrent(4) }}>入住记录</div>
                <div className={tabCurrent === 5 ? 'tab-btn fl current' : 'tab-btn fl'} onClick={() => { setTabCurrent(5) }}>入住回访记录</div>
                <div className={tabCurrent === 7 ? 'tab-btn fl current' : 'tab-btn fl'} onClick={() => { setTabCurrent(7) }}>其他收入</div>
            </Fragment>}
        </Space>

        <div className="tab-cont">
            {tabCurrent === 0 ? <div className="cont">
                <RecordSalesFollow />
            </div> : null}
            {tabCurrent === 1 ? <div className="cont">
                <RecordVisitStore />
            </div> : null}
            {tabCurrent === 2 ? <div className="cont">
                <RecordPay />
            </div> : null}
            {tabCurrent === 8 ? <div className="cont">
                <RecordRefund />
            </div> : null}

            {clientData?.check_in_status === 1 && <Fragment>
                {tabCurrent === 3 ? <div className="cont">
                    <RecordMinionFollow />
                </div> : null}
                {tabCurrent === 4 ? <div className="cont">
                    <RecordCheckInDetail />
                </div> : null}
            </Fragment>}

            {(clientData?.check_in_status === 2 || clientData?.check_in_status === 4) && <Fragment>
                {tabCurrent === 3 ? <div className="cont">
                    <RecordMinionFollow />
                </div> : null}
                {tabCurrent === 4 ? <div className="cont">
                    <RecordCheckInDetail />
                </div> : null}
                {tabCurrent === 5 ? <div className="cont">
                    <RecordCheckInInterview />
                </div> : null}
                {tabCurrent === 7 ? <div className="cont">
                    <RecordOtherIncome />
                </div> : null}
            </Fragment>}

            {clientData?.check_in_status === 3 && <Fragment>
                {tabCurrent === 3 ? <div className="cont">
                    <RecordMinionFollow />
                </div> : null}
                {tabCurrent === 4 ? <div className="cont">
                    <RecordCheckInDetail />
                </div> : null}
                {tabCurrent === 5 ? <div className="cont">
                    <RecordCheckInInterview />
                </div> : null}
                {tabCurrent === 7 ? <div className="cont">
                    <RecordOtherIncome />
                </div> : null}
            </Fragment>}
        </div>
    </div>
}